var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalancer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "63px",
    viewBox: "0 0 480 203",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "container",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play",
    transform: "translate(0.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-container-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.214844,14.207031 C400.667969,5.503906 392.359375,-0.300781 383.65625,1.246094 C374.953125,2.792969 369.148438,11.101562 370.695312,19.808594 L379.03125,67.007812 L410.542969,61.40625 L402.214844,14.207031 Z",
    id: "Path",
    fill: "#68B0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.480469,67.488281 C466.910156,58.796875 458.617188,53.007812 449.921875,54.527344 L410.558594,61.488281 L409.59375,61.65625 L410.542969,61.488281 L395.664062,64.109375 L379.039062,67.007812 L290.480469,82.605469 L276.640625,85.085938 L301.679688,113.167969 L315.519531,110.765625 L455.519531,86.046875 C463.136719,84.652344 468.683594,78.03125 468.71875,70.285156 C468.71875,69.347656 468.640625,68.410156 468.480469,67.488281 Z",
    id: "Path",
    fill: "#D9D9D8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C0C0C0",
    points: "315.519531 110.765625 301.679688 113.167969 276.640625 85.085938 290.480469 82.605469 292.640625 85.085938"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rotate-container-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.894531,122.613281 L95.40625,117.015625 L87.070312,69.742188 C85.527344,61.039062 77.21875,55.242188 68.515625,56.785156 C59.8125,58.332031 54.011719,66.640625 55.558594,75.34375 L63.894531,122.613281 Z",
    id: "Path",
    fill: "#68B0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71875,103.808594 L24.480469,129.566406 C16.863281,130.960938 11.316406,137.582031 11.28125,145.328125 C11.28125,146.265625 11.359375,147.203125 11.519531,148.125 C13.089844,156.816406 21.382812,162.605469 30.078125,161.085938 L160,138.125 L176,135.328125 L176,115.808594 L189.679688,100.445312 L170.71875,103.808594 Z",
    id: "Path",
    fill: "#D9D9D8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C0C0C0",
    points: "189.679688 100.445312 176 115.808594 176 135.328125 160 138.125 160 115.808594 170.71875 103.808594"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472,203.808594 L8,203.808594 C3.582031,203.808594 0,200.226562 0,195.808594 C0,191.386719 3.582031,187.808594 8,187.808594 L472,187.808594 C476.417969,187.808594 480,191.386719 480,195.808594 C480,200.226562 476.417969,203.808594 472,203.808594 Z",
    id: "Path",
    fill: "#68b0cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,115.808594 L304,195.808594 L176,195.808594 L176,115.808594 L189.679688,100.445312 L228.078125,57.246094 C231.113281,53.855469 235.449219,51.917969 240,51.917969 C244.550781,51.917969 248.886719,53.855469 251.921875,57.246094 L276.640625,85.085938 L301.679688,113.167969 L304,115.808594 Z",
    id: "Path",
    fill: "#68B0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,107.808594 C256,116.644531 248.835938,123.808594 240,123.808594 C231.164062,123.808594 224,116.644531 224,107.808594 C224,98.96875 231.164062,91.808594 240,91.808594 C248.835938,91.808594 256,98.96875 256,107.808594 Z",
    id: "Path",
    fill: "#F0FAFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancer);
export default __webpack_public_path__ + "static/media/Balancer.b39cd94b153779cdd4218f11cfe711d9.svg";
export { ForwardRef as ReactComponent };